function uniqueTitleName($q, server) {
  return function checkTitleNameUniqueness(modelValue, viewValue, scope) {
    var value = modelValue || viewValue;
    var model = scope.model;

    return server
      .existTitleName(value, model.Id)
      .then(function (result) {
        console.log(result);
        if (result) {
          console.log(value);
          console.log(model.Id);
          return $q.reject("Title Name is not unique");
        } else {
          console.log(value);
          console.log(model.Id);
          return true;
        }
      })
      .catch(function () {
        // console.log(value);
        // console.log(model.Id);
        // return true;
        return $q.reject("Something happened");
      });
  };
}

export default uniqueTitleName;
